import { renderDate } from '../utility/addressZoneHelper';

export const ZONE_GRID_COLUMNS = [
  { field: 'ZoneCode', headerName: 'Zone Code', width: 150 },
  { field: 'Description', headerName: 'Description', width: 220 },
  { field: 'AgencyID', headerName: 'Agency', width: 150 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 150 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 150 },
];

export const DETAIL_FIELDS = [
  { field: 'ZoneCode', label: 'Zone Code' },
  { field: 'Description', label: 'Description' },
  { field: 'AgencyID', label: 'Agency' },
];
